  (function () {
  const norm = (v) => (v || "").toString().trim().toLowerCase();

  function selectedColor(section) {
    // Busca el bloque "Color" de Dawn
    const blocks = section.querySelectorAll(".product-form__input");
    for (const b of blocks) {
      const legend = b.querySelector("legend");
      const label = b.querySelector(".form__label");
      const text = norm((legend && legend.textContent) || (label && label.textContent) || "");
      if (!text.includes("color") && !text.includes("colour")) continue;

      const checked = b.querySelector('input[type="radio"]:checked');
      if (checked) return norm(checked.value);

      const select = b.querySelector("select");
      if (select) return norm(select.value);
    }
    return null;
  }

  function filterThumbs(section) {
    const c = selectedColor(section);
    if (!c) return;

    const lis = section.querySelectorAll(".thumbnail-list li[data-media-color]");
    lis.forEach((li) => {
      const tag = norm(li.getAttribute("data-media-color"));
      const show = tag === "" || tag === c;
      li.toggleAttribute("hidden", !show);
    });
  }

  function init() {
    document.querySelectorAll('[id^="MainProduct-"]').forEach(filterThumbs);

    document.addEventListener("change", (e) => {
      const section = e.target?.closest?.('[id^="MainProduct-"]');
      if (section) filterThumbs(section);
    });
  }

  document.addEventListener("DOMContentLoaded", init);
})();
